import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/hooks";

interface Error {
  message: string;
  severity?: "error" | "waring";
}

const useQuery = <T>(
  action: any,
  selector: any,
  dependencies: (string | undefined)[]
): {
  data: T;
  isLoading: boolean;
  error: Error | null;
} => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const data = useAppSelector(selector(dependencies[0])) as T;


  const fetch = () => {
    setIsLoading(true);

    dispatch(action(dependencies[0]))
      .catch(() => {
        setError(error);
      })
      .then(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (dependencies.every((dependency) => !!dependency)) {
      fetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },  dependencies);

  return {
    isLoading,
    error,
    data,
  };
};

export default useQuery;
